import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { TenantIds } from '../enums/tenants.enum';
import { TENANT_CONFIGS } from '../config/tenant.config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  private currentTenantId = new BehaviorSubject<TenantIds>(TenantIds.FRONT_OFFICE_METHOD);

  constructor(private http: HttpClient) {
    this.initializeTenant();
  }

  private initializeTenant(): void {
    const currentUrl = this.getCurrentUrl();
    const tenantId = this.getTenantIdFromUrl(currentUrl);
    
    if (tenantId) {
      this.currentTenantId.next(tenantId);
      this.updateFavicon(tenantId);
      document.title = this.getTenantName(tenantId);
    }
  }

  private getCurrentUrl(): string {
    return window.location.host;
  }

  private getTenantIdFromUrl(url: string): TenantIds | null {
    // Find the tenant config that matches the current URL
    const tenantConfig = TENANT_CONFIGS.find(config => 
      config.urls.some(tenantUrl => url.includes(tenantUrl))
    );

    return tenantConfig?.id || null;
  }

  private updateFavicon(tenantId: TenantIds): void {
    const favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;
    if (favicon) {
      switch (tenantId) {
        case TenantIds.RADFORD:
          favicon.href = 'assets/images/tenants/radfordmoneyball/favicon.ico';
          break;
        case TenantIds.MUSTANG:
          favicon.href = 'assets/images/tenants/mustangmoneyball/favicon.ico';
          break;
        case TenantIds.FRONT_OFFICE_METHOD:
        default:
          favicon.href = 'assets/images/favicon.ico';
          break;
      }
    }
  }

  getCurrentTenantId(): Observable<TenantIds> {
    return this.currentTenantId.asObservable();
  }

  getTenantName(tenantId: TenantIds): string {
    switch (tenantId) {
      case TenantIds.RADFORD:
        return 'Radford Money Ball';
      case TenantIds.MUSTANG:
        return 'Mustang Money Ball';
      case TenantIds.FRONT_OFFICE_METHOD:
      default:
        return 'Front Office Method';
    }
  }

  getTenantAbbreviation(tenantId: TenantIds): string {
    switch (tenantId) {
      case TenantIds.RADFORD:
        return 'RMB';
      case TenantIds.MUSTANG:
        return 'MMB';
      case TenantIds.FRONT_OFFICE_METHOD:
      default:
        return 'FOM';
    }
  }

  get tenantAbbreviation$(): Observable<string> {
    return this.getCurrentTenantId().pipe(
      map(tenantId => this.getTenantAbbreviation(tenantId))
    );
  }
} 